function updateUIStateWithServiceCollection(serviceCollection, affectedUIService) {
    serviceCollection.getControllerRelatedUIServices().forEach((service, uiServiceName) => {
        // 检查controller是否影响对应的UIService
        if (affectedUIService.has(uiServiceName)) {
            service.updateState();
        }
    });
}

export { updateUIStateWithServiceCollection };
//# sourceMappingURL=update-ui-state-with-service-collection.js.map
